import { Location } from '@angular/common';
import { NavigationError, Router } from '@angular/router';

/** Ошибка загрузки файла сборки: так её пишут Chrome и Edge, Firefox, Safari. */
const STALE_CHUNK_ERROR = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

/** Метка перезагрузки в sessionStorage вкладки и сколько она действует. */
const RELOAD_MARKER_KEY = 'stale-chunk-reload-at';
const RELOAD_MARKER_TTL_MS = 10_000;

/**
 * Вкладка открыта до выката, а файлов прежней сборки на сервере уже нет: переход в раздел падает с
 * «Failed to fetch dynamically imported module». Один раз перезагружаем страницу на адрес, куда шёл переход, —
 * загрузится новая сборка. Повторный сбой в течение 10 секунд не перезагружаем: файла нет и в новой сборке,
 * и бесконечной перезагрузки не будет (#29300).
 */
export function reloadOnStaleChunk(router: Router, location: Location): void {
    router.events.subscribe(event => {
        if (!(event instanceof NavigationError) || !STALE_CHUNK_ERROR.test(String(event.error?.message ?? event.error))) {
            return;
        }

        const lastReload = Number(sessionStorage.getItem(RELOAD_MARKER_KEY) || 0);
        if (Date.now() - lastReload < RELOAD_MARKER_TTL_MS) {
            return;
        }

        sessionStorage.setItem(RELOAD_MARKER_KEY, String(Date.now()));
        // Адрес меняем без перехода и перезагружаем: при маршрутизации по # смена одного # страницу не перезагрузила бы.
        window.history.replaceState(window.history.state, '', location.prepareExternalUrl(event.url));
        window.location.reload();
    });
}
